/** True when exercise is private to its creator (My Exercise only mode). */
export function readExerciseMyOnlyFlag(exercise) {
  const raw = exercise?.isMyExerciseOnly ?? exercise?.is_my_exercise_only;
  return raw === true || raw === 'true' || raw === 1;
}

/**
 * Assignments page: super users must not see "Already Assigned" for My Exercise only exercises
 * (assignment may exist for access; UI stays unassigned).
 */
export function exerciseCountsAsAssignedInAssignmentsUi(exercise, viewer, hasSuperUserAccessFn) {
  const isAssigned =
    exercise?.is_assigned === true ||
    exercise?.is_assigned === 'true' ||
    exercise?.is_assigned === 1;
  if (hasSuperUserAccessFn(viewer) && readExerciseMyOnlyFlag(exercise)) {
    return false;
  }
  return isAssigned;
}
